import { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import * as api from '../api';
import LoadingSpinner from '../components/LoadingSpinner';
import { AuthContext } from '../context/AuthContext';
import { BalanceContext } from '../context/BalanceContext';

export default function RedirectBalancesPage() {
  const { t } = useTranslation();
  const nav = useNavigate();
  const { setToken } = useContext(AuthContext);
  const { setBalances } = useContext(BalanceContext);

  const [error, setError] = useState<string>();

  const handlePayClick = async (vals: {
    lastName: string;
    orderNumber: string;
  }) => {
    try {
      const res = await api.balances(vals);
      const updatedBalances = await Promise.all(
        res.map(async (item) => {
          //initial toPay fill
          let toPay = {
            amount: item.payment.balance.amount,
            currency: { id: 724, code: 'TRY', name: 'Turkish Lira' },
            currencyExchangeRate: 0,
          } as api.ApiAmountWithCurrency;

          if (toPay.amount > 0)
            toPay = await api.currencyExchange(
              item.payment.balance.currency.code,
              'TRY',
              item.payment.balance.amount,
            );

          return {
            ...item,
            payment: {
              ...item.payment,
              loyalty: {
                points: 0,
                fiat: 0,
              },
              received: {
                amount:
                  (item.payment.total.amount || 0) -
                  (item.payment.balance.amount || 0),
                currency: item.payment.balance.currency,
              },
              toPay: {
                amount: toPay?.amount || 0,
                currencyExchangeRate:
                  item.payment.balance.amount > 0
                    ? item.payment.balance.amount / toPay?.amount
                    : 0, // 1 TRY => ?€ | ?$...
                // todo implement company currency
                currency: toPay.currency || null,
              },
            },
          };
        }),
      );

      setBalances(updatedBalances);
      nav('/balances');
    } catch (e: any) {
      setError(e.detail || e.message || t('redirectBalancesPage.errorText'));
    }
  };

  const [searchParams] = useSearchParams();
  useEffect(() => {
    const lastName = searchParams.get('lastname');
    const orderNumber = searchParams.get('pnr');
    const tokenParam = searchParams.get('token');

    if (tokenParam) {
      localStorage.setItem('id_token', tokenParam);
      setToken(tokenParam);
    }

    if (lastName && orderNumber) {
      handlePayClick({ lastName, orderNumber });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams]);

  if (error) {
    return (
      <Box p={2}>
        <Typography color="danger">{error}</Typography>
      </Box>
    );
  }

  return <LoadingSpinner loadingText={t('redirectBalancesPage.loading')} />;
}
